import { useScreenSizeRatio } from 'hooks/useScreenSizeRatio';
import React from 'react';

import * as S from './PhoneHandle.styles';

type PhoneHandleProps = {
  onHandleClicked: () => void;
};

const PhoneHandle: React.FC<PhoneHandleProps> = ({ onHandleClicked }) => {
  const sizeRatio = useScreenSizeRatio();

  return (
    <S.PhoneWrapper sizeRatio={sizeRatio} onClick={onHandleClicked}>
      <S.RingingIndicator />
    </S.PhoneWrapper>
  );
};

export default PhoneHandle;
